import { useMemo } from 'react';
import { useUserStore } from '@/client/stores/user';
import { useIsSuperAdmin } from '@/client/hooks/useIsSuperAdmin';

// Whether the current user holds `code`. Superadmin (administrator_super role)
// passes every gate. Both the roles and the effective permission codes come
// from the session user (users/info) — no per-gate network calls.
export const useHasPermission = (code: string) => {
  const permissions = useUserStore((s) => s.user?.permissions);
  const { isSuperAdmin, isLoading } = useIsSuperAdmin();

  const hasPermission = useMemo(
    () => Array.isArray(permissions) && permissions.includes(code),
    [permissions, code]
  );

  return { hasPermission, isSuperAdmin, isLoading, isError: false };
};

export default useHasPermission;
